import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  OutlinedInput,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";

import {
  IProductParams,
  FEEDBACK_TYPE_FEEDBACK,
  FEEDBACK_TYPE_BUGS,
  FEEDBACK_TYPE_FEATURE_REQ,
  INVOKE_TYPE_MANUAL,
  RATING_ICON_TYPE_STAR,
  PLATFORM_TYPE_BROWSER,
  POS_RIGHT_MIDDLE,
  FEEDBACK_FLOW_STATIC,
  IFeedbackAgentSettings,
  IProductInfo,
  STATUS_PRODUCT_ACTIVE,
  webTechs,
  TYPE_NONE,
  brandingIF,
  FEEDBACK_FLOW_DYNAMIC,
} from "../../model";
import { UserLoginInfo } from "../../types/context";
import { UserContext } from "../../context/userContext";
import { useContext } from "react";
import { appLogger, Http } from "../../utils";
import Editor from "../../utils/common/Editor";
import { withSnackbar } from "../../utils/common/SnackbarHoc";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import { cloneDeep } from "lodash";

import EmailSettingsHeader from "./EmailSettingsHeader";
import {
  enableFeedback,
  enableBugReport,
  enableFeatureRequest,
  enableChatbot,
} from "../../utils/config";

interface TabPanelProps {
  children?: any;
  index: number;
  value: number;
}

const feedbackRatingslist = [
  { id: "0", name: "Any" },
  { id: "1", name: "1 star rating" },
  { id: "2", name: "2 star ratings" },
  { id: "3", name: "3 star ratings" },
  { id: "4", name: "4 star ratings" },
  { id: "5", name: "5 star ratings" },
];

const defaultBranding: brandingIF = {
  "branding-cuvo-popup-dialog-agent-bg": "#f7f8f8",
  "branding-cuvo-popup-dialog-main-title": "#011348",
  "branding-cuvo-popup-dialog-main-title-font-family": "Open Sans",
  "branding-cuvo-popup-dialog-main-title-font-weight": "700",
  "branding-cuvo-popup-dialog-main-title-font-style": "normal",
  "branding-cuvo-popup-dialog-main-title-font-size": "34px",
  "branding-cuvo-popup-dialog-main-subtitle": "#040000",
  "branding-cuvo-popup-dialog-main-subtitle-font-family": "Open Sans",
  "branding-cuvo-popup-dialog-main-subtitle-font-weight": "500",
  "branding-cuvo-popup-dialog-main-subtitle-font-style": "normal",
  "branding-cuvo-popup-dialog-main-subtitle-font-size": "16px",
  "branding-cuvo-popup-dialog-card-bg": "#ffffff",
  "branding-cuvo-popup-dialog-card-title": "#040000",
  "branding-cuvo-popup-dialog-card-title-font-family": "Open Sans",
  "branding-cuvo-popup-dialog-card-title-font-weight": "700",
  "branding-cuvo-popup-dialog-card-title-font-style": "normal",
  "branding-cuvo-popup-dialog-card-title-font-size": "20px",
  "branding-cuvo-popup-dialog-card-subtitle": "#040000",
  "branding-cuvo-popup-dialog-card-subtitle-font-family": "Open Sans",
  "branding-cuvo-popup-dialog-card-subtitle-font-weight": "500",
  "branding-cuvo-popup-dialog-card-subtitle-font-style": "normal",
  "branding-cuvo-popup-dialog-card-subtitle-font-size": "16px",
  "branding-cuvo-primary-button-bg": "#0157ff",
  "branding-cuvo-primary-button-text-color": "#ffffff",
  "branding-cuvo-primary-button-text-font-family": "Open Sans",
  "branding-cuvo-primary-button-text-font-style": "normal",
  "branding-cuvo-primary-button-text-font-weight": "400",
  "branding-cuvo-primary-button-text-font-size": "16px",
  "branding-cuvo-primary-button-border-color": "#0157ff",
  "branding-cuvo-secondary-button-bg": "#00000070",
  "branding-cuvo-secondary-button-text-color": "#ffffff",
  "branding-cuvo-secondary-button-text-font-family": "Open Sans",
  "branding-cuvo-secondary-button-text-font-style": "normal",
  "branding-cuvo-secondary-button-text-font-weight": "400",
  "branding-cuvo-secondary-button-text-font-size": "16px",
  "branding-cuvo-secondary-button-border-color": "#00000070",
  "branding-cuvo-input-label-color": "#040000",
  "branding-cuvo-input-label-font-family": "Open Sans",
  "branding-cuvo-input-label-font-style": "normal",
  "branding-cuvo-input-label-font-weight": "500",
  "branding-cuvo-input-label-font-size": "16px",
  "branding-cuvo-input-field-text-color": "#000",
  "branding-cuvo-input-field-bg-color": "#f4f5f5",
  "branding-cuvo-attachment-helper-color": "#00000060",
  "branding-cuvo-attachment-helper-font-family": "Open Sans",
  "branding-cuvo-attachment-helper-font-style": "normal",
  "branding-cuvo-attachment-helper-font-weight": "500",
  "branding-cuvo-attachment-helper-font-size": "16px",
  "branding-cuvo-card-svg-fg-color": "#0157ff",
  "branding-cuvo-card-svg-bg-color": "#0157ff1a",
  "branding-cuvo-selected-star-color": "#ffbc01",
  "branding-cuvo-unselected-star-color": "#d9d6d6",
  "branding-cuvo-card-border-color": "#00000070",
  "branding-cuvo-card-border-radius": "8px",
  "branding-cuvo-input-border-color": "#00000070",
  "branding-cuvo-input-border-radius": "8px",
  "branding-cuvo-comments-field-height": "100px",
  "branding-cuvo-editor-font-size": "16px",
  "branding-cuvo-editor-font-family": "Open Sans",
  "branding-cuvo-primary_btn-border-radius": "4px",
  "branding-cuvo-secondary_btn-border-radius": "4px",
  "branding-cuvo-selected-start-rating-uri": "",
  "branding-cuvo-unselected-start-rating-uri": "",
};

const defaultFeedbackAgentSettings: IFeedbackAgentSettings = {
  //  platform: PLATFORM_TYPE_BROWSER,
  feedbackTypes: [
    FEEDBACK_TYPE_FEEDBACK,
    FEEDBACK_TYPE_BUGS,
    FEEDBACK_TYPE_FEATURE_REQ,
  ],
  showLogo: false,
  invokeDelay: 5,
  invokeOn: [INVOKE_TYPE_MANUAL],
  thanksStr: "Thank You",
  title: "Cuvo - Customer Voice",
  subtitle: "Voice your idea or concerns with audio-visual enhancement",
  uploadFileMaxSize: "400",
  videoAudioMaxDuration: "1.5",
  disableDefaultBtn: false,
  disableCuvo: false,
  requireEmail: true,
  captureSystemDetails: true,
  remoteBtns: [],
  widgetLookAndFeel: {
    bgColor: "#042e5b",
    fgColor: "#ffffff",
    font: "inherit",
    fontWeight: 400,
    fontStyle: "normal",
    text: "Feedback",
    icon: "",
    position: POS_RIGHT_MIDDLE,
    custom: {
      top: "",
      bottom: "",
      right: "",
      left: "",
      borderRadius: "",
      rotation: "",
      margin: "",
      padding: "",
    },
  },
  bugSettings: {
    categories: [],
    severities: ["High", "Medium", "Low"],
    categoryHeading: "Choose the area where you noticed the issue",
    severityHeading: "Severity of the issue",
    stdFeedbackHeading: "Choose all options that relate to the issue",
    generalCommentsHeading: "Describe your issue",
    attachmentHelp:
      "Choosing attachment will ask for permission to access required system resources. Please provide access for the attachments to work. The feedback dialog might close and allow you to navigate to any app page. Press capture or stop or open buttons in the dialog or toolbar to attach.",
    dialogMsg:
      "Help us understand better with audio/video/screenshot attachment",
    thanksMsg: "We will attend to your concern.",
    icon: "",
    title: "Report an issue",
    tooltip: "Tell us your concern",
    reqComments: true,
    reqDisplayEmail: false,
    showSeverity: true,
    reqCategory: false,
  },
  feedbackSettings: {
    type: FEEDBACK_FLOW_STATIC,
    categories: [],
    ratingIcon: RATING_ICON_TYPE_STAR,
    ratingLimit: 3,
    categoryHeading: "Choose the area related to your feedback",
    ratingHeading: "How would you rate us",
    stdFeedbackHeading: "Choose all options that relate to your feedback",
    generalCommentsHeading: "Anything more you want us to know",
    attachmentHelp:
      "Choosing attachment will ask for permission to access required system resources. Please provide access for the attachments to work. The feedback dialog might close and allow you to navigate to any app page. Press capture or stop or open buttons in the dialog or toolbar to attach.",
    dialogMsg:
      "Help us understand better with audio/video/screenshot attachment",
    thanksMsg: "We appreciate your feedback",
    icon: "",
    title: "Provide Feedback",
    tooltip: "Tell us your experience",
    reqComments: true,
    reqDisplayEmail: false,
    reqCategory: false,
  },
  featureReqSettings: {
    categories: [],
    categoryHeading: "Choose the area related to your request",
    stdFeedbackHeading: "Choose all options that relate to your request",
    generalCommentsHeading: "Describe your request",
    attachmentHelp:
      "Choosing attachment will ask for permission to access required system resources. Please provide access for the attachments to work. The feedback dialog might close and allow you to navigate to any app page. Press capture or stop or open buttons in the dialog or toolbar to attach.",
    dialogMsg:
      "Are there any feature or enhacements that could make your experience better?",
    thanksMsg: "We appreciate your thoughts and consideration",
    icon: "",
    title: "Request a feature",
    tooltip: "How could we enhance your experience",
    reqComments: true,
    reqCategory: false,
  },
  bannerType: TYPE_NONE,
  bannerImage: "",
  bannerText: "",
  branding: defaultBranding,
  qrSettings: {
    addQR: true,
    qrHeading: "Scan this QR code with your phone",
    qrSubHeading:
      "To provide additional context on your query, please scan the QR code below. You will have an option to submit a screenshot, screen recording or audio recording.",
  },
};

const EmailSettings = ({
  snackbarShowMessage,
}: {
  snackbarShowMessage: any;
}) => {
  const { productId, versionId } = useParams();
  const location: any = useLocation();
  const navigate = useNavigate();

  const {
    userInfo,
    orgId,
    setWidgIntgSettingsAccordianContext,
    enabledFeatures,
    GenSettingsAccordianContext,
    setGenSettingsAccordianContext,
  } = useContext(UserContext) as UserLoginInfo;

  const [value, setValue] = useState(0);

  const [errMsg, setErrMsg] = useState<any | null>({});
  const [productParams, setProductParams] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const [fdCheck, setFdChecked] = useState(false);
  const [bugCheck, setBugChecked] = useState(false);
  const [featureCheck, setFeatureChecked] = useState(false);

  const [bugSeverities, setBugSeverities] = useState<string[]>([]);

  function changePtoBrTags(unFormatted: string) {
    let formatted = unFormatted;
    formatted = formatted.replaceAll("<p>", "<br>").replaceAll("</p>", "");
    formatted = formatted.replace("<br>", "");
    formatted = "<p>" + formatted + "</p>";
    return formatted;
  }

  function changeEmailTags(): boolean {
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].emailConfig
    ) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        productParams.products[0].emailConfig.emailSalutation &&
        Object.keys(productParams.products[0].emailConfig.emailSalutation)
          .length > 0
      ) {
        Object.keys(productParams.products[0].emailConfig.emailSalutation).map(
          (fdbkType) => {
            if (
              temp &&
              temp.products &&
              temp.products[0] &&
              temp.products[0].emailConfig &&
              temp.products[0].emailConfig.emailSalutation[fdbkType] &&
              temp.products[0].emailConfig.emailSalutation[fdbkType].length > 0
            ) {
              temp.products[0].emailConfig.emailSalutation[fdbkType] =
                changePtoBrTags(
                  temp.products[0].emailConfig.emailSalutation[fdbkType]
                );
            }
          }
        );
      }
      if (
        productParams.products[0].emailConfig.emailOpeningParagraph &&
        Object.keys(productParams.products[0].emailConfig.emailOpeningParagraph)
          .length > 0
      ) {
        Object.keys(
          productParams.products[0].emailConfig.emailOpeningParagraph
        ).map((fdbkType) => {
          if (
            temp &&
            temp.products &&
            temp.products[0] &&
            temp.products[0].emailConfig &&
            temp.products[0].emailConfig.emailOpeningParagraph[fdbkType] &&
            temp.products[0].emailConfig.emailOpeningParagraph[fdbkType]
              .length > 0
          ) {
            temp.products[0].emailConfig.emailOpeningParagraph[fdbkType] =
              changePtoBrTags(
                temp.products[0].emailConfig.emailOpeningParagraph[fdbkType]
              );
          }
        });
      }
      if (
        productParams.products[0].emailConfig.emailText &&
        Object.keys(productParams.products[0].emailConfig.emailText).length > 0
      ) {
        Object.keys(productParams.products[0].emailConfig.emailText).map(
          (fdbkType) => {
            if (
              temp &&
              temp.products &&
              temp.products[0] &&
              temp.products[0].emailConfig &&
              temp.products[0].emailConfig.emailText[fdbkType] &&
              temp.products[0].emailConfig.emailText[fdbkType].length > 0
            ) {
              temp.products[0].emailConfig.emailText[fdbkType] =
                changePtoBrTags(
                  temp.products[0].emailConfig.emailText[fdbkType]
                );
            }
          }
        );
      }
      if (
        productParams.products[0].emailConfig.emailClosingParagraph &&
        Object.keys(productParams.products[0].emailConfig.emailClosingParagraph)
          .length > 0
      ) {
        Object.keys(
          productParams.products[0].emailConfig.emailClosingParagraph
        ).map((fdbkType) => {
          if (
            temp &&
            temp.products &&
            temp.products[0] &&
            temp.products[0].emailConfig &&
            temp.products[0].emailConfig.emailClosingParagraph[fdbkType] &&
            temp.products[0].emailConfig.emailClosingParagraph[fdbkType]
              .length > 0
          ) {
            temp.products[0].emailConfig.emailClosingParagraph[fdbkType] =
              changePtoBrTags(
                temp.products[0].emailConfig.emailClosingParagraph[fdbkType]
              );
          }
        });
      }
      if (
        productParams.products[0].emailConfig.emailSignature &&
        Object.keys(productParams.products[0].emailConfig.emailSignature)
          .length > 0
      ) {
        Object.keys(productParams.products[0].emailConfig.emailSignature).map(
          (fdbkType) => {
            if (
              temp &&
              temp.products &&
              temp.products[0] &&
              temp.products[0].emailConfig &&
              temp.products[0].emailConfig.emailSignature[fdbkType] &&
              temp.products[0].emailConfig.emailSignature[fdbkType].length > 0
            ) {
              temp.products[0].emailConfig.emailSignature[fdbkType] =
                changePtoBrTags(
                  temp.products[0].emailConfig.emailSignature[fdbkType]
                );
            }
          }
        );
      }
      setProductParams(temp);
    }
    return true;
  }

  function stripTags(unStripped: any) {
    const parseHTML = new DOMParser().parseFromString(unStripped, "text/html");
    return parseHTML.body.textContent || "";
  }

  const mandatoryCheck = () => {
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].emailConfig &&
      productParams.products[0].emailConfig.feedbackTypes &&
      productParams.products[0].emailConfig.feedbackTypes.includes(
        FEEDBACK_TYPE_FEEDBACK
      )
    ) {
      if (
        !(
          productParams.products[0].emailConfig.emailSubject &&
          productParams.products[0].emailConfig.emailSubject[
            FEEDBACK_TYPE_FEEDBACK
          ]
        )
      ) {
        snackbarShowMessage(
          "You must provide email subject for feedback auto reply mail in Email settings",
          "error",
          3000
        );
        const updatedValue = {
          feedbackEmailSubErr: "You must provide email subject",
        };
        return false;
      }
      if (
        !(
          productParams.products[0].emailConfig.emailText &&
          productParams.products[0].emailConfig.emailText[
            FEEDBACK_TYPE_FEEDBACK
          ]
        )
      ) {
        snackbarShowMessage(
          "You must provide email body for feedback auto reply mail in Email settings",
          "error",
          3000
        );
        const updatedValue = {
          feedbackEmailBodyErr: "You must provide email body",
        };
        return false;
      }
      if (
        productParams.products[0].emailConfig.emailText &&
        productParams.products[0].emailConfig.emailText[FEEDBACK_TYPE_FEEDBACK]
      ) {
        const strippedVal = stripTags(
          productParams.products[0].emailConfig.emailText[
            FEEDBACK_TYPE_FEEDBACK
          ]
        );
        if (!strippedVal) {
          snackbarShowMessage(
            "You must provide email body for feedback auto reply mail in Email settings",
            "error",
            3000
          );
          const updatedValue = {
            feedbackEmailBodyErr: "You must provide email body",
          };
          return false;
        }
      }
    }
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].emailConfig &&
      productParams.products[0].emailConfig.feedbackTypes &&
      productParams.products[0].emailConfig.feedbackTypes.includes(
        FEEDBACK_TYPE_BUGS
      )
    ) {
      if (
        !(
          productParams.products[0].emailConfig &&
          productParams.products[0].emailConfig.emailSubject &&
          productParams.products[0].emailConfig.emailSubject[FEEDBACK_TYPE_BUGS]
        )
      ) {
        snackbarShowMessage(
          "You must provide email subject for ticket auto reply mail in Email settings",
          "error",
          3000
        );
        const updatedValue = {
          bugEmailSubErr: "You must provide email subject",
        };
        return false;
      }
      if (
        !(
          productParams.products[0].emailConfig.emailText &&
          productParams.products[0].emailConfig.emailText[FEEDBACK_TYPE_BUGS]
        )
      ) {
        snackbarShowMessage(
          "You must provide email body for ticket auto reply mail in Email settings",
          "error",
          3000
        );
        const updatedValue = {
          bugEmailBodyErr: "You must provide email body",
        };
        return false;
      }
      if (
        productParams.products[0].emailConfig.emailText &&
        productParams.products[0].emailConfig.emailText[FEEDBACK_TYPE_BUGS]
      ) {
        const strippedVal = stripTags(
          productParams.products[0].emailConfig.emailText[FEEDBACK_TYPE_BUGS]
        );
        if (!strippedVal) {
          snackbarShowMessage(
            "You must provide email body for ticket auto reply mail in Email settings",
            "error",
            3000
          );
          const updatedValue = {
            bugEmailBodyErr: "You must provide email body",
          };
          return false;
        }
      }
    }
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].emailConfig &&
      productParams.products[0].emailConfig.feedbackTypes &&
      productParams.products[0].emailConfig.feedbackTypes.includes(
        FEEDBACK_TYPE_FEATURE_REQ
      )
    ) {
      if (
        !(
          productParams.products[0].emailConfig.emailSubject &&
          productParams.products[0].emailConfig.emailSubject[
            FEEDBACK_TYPE_FEATURE_REQ
          ]
        )
      ) {
        snackbarShowMessage(
          "You must provide email subject for feature request auto reply mail in Email settings",
          "error",
          3000
        );
        const updatedValue = {
          featureEmailSubErr: "You must provide email subject",
        };
        return false;
      }
      if (
        !(
          productParams.products[0].emailConfig.emailText &&
          productParams.products[0].emailConfig.emailText[
            FEEDBACK_TYPE_FEATURE_REQ
          ]
        )
      ) {
        snackbarShowMessage(
          "You must provide email body for feature request auto reply mail in Email settings",
          "error",
          3000
        );
        const updatedValue = {
          featureEmailBodyErr: "You must provide email body",
        };
        return false;
      }
      if (
        productParams.products[0].emailConfig.emailText &&
        productParams.products[0].emailConfig.emailText[
          FEEDBACK_TYPE_FEATURE_REQ
        ]
      ) {
        const strippedVal = stripTags(
          productParams.products[0].emailConfig.emailText[
            FEEDBACK_TYPE_FEATURE_REQ
          ]
        );
        if (!strippedVal) {
          snackbarShowMessage(
            "You must provide email body for feature request auto reply mail in Email settings",
            "error",
            3000
          );
          const updatedValue = {
            featureEmailBodyErr: "You must provide email body",
          };
          return false;
        }
      }
    }
    return true;
  };
  const handleSave = () => {
    if (mandatoryCheck()) {
      const postData = productParams;
      setLoading(true);
      appLogger.info(
        {
          infoObj: {
            method: "putUpdate",
            component: "add-products",
            fileName: "index.tsx",
            productParams: postData,
          },
        },
        "Update product"
      );
      Http.put({
        url: `/api/v2/products`,
        body: {
          ...postData,
        },
        state: userInfo,
      })
        .then((response: any) => {
          setLoading(false);
          if (response && response.message === "Product already exists") {
            snackbarShowMessage("Product already exists", "error", 3000);
          } else {
            snackbarShowMessage("product saved successfully", "success", 3000);
            // setTimeout(() => {
            //   navigate(-1);
            // }, 2000);
          }
        })
        .catch((error: any) => {
          appLogger.error({
            errObj: {
              method: "putUpdate",
              component: "add-products",
              fileName: "index.tsx",
              err: error,
            },
          });
          setLoading(false);
          snackbarShowMessage(error.message, "error");
        });
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleEmailSeverity = (key: string) => {
    appLogger.info({
      infoObj: {
        method: "handleEmailSeverity",
        component: "add-product",
        fileName: "emailSettings.tsx",
        selectSeverity: key,
      },
    });
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].emailConfig &&
        temp.products[0].emailConfig.severityLimit &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        const severity = temp.products[0].emailConfig.severityLimit;
        // if emailConfig.severityLimit object is empty, we set it here for the first time
        // if (Object.keys(severity).length < bugSeverities.length) {
        //   // const severityArray =
        //   //   temp.products[0].feedbackAgentSettings?.bugSettings.severities;
        //   const setSeverity: any = {};
        //   bugSeverities.forEach((val) => {
        //     setSeverity[val] = false;
        //   });
        //   setSeverity[key] = true;
        //   temp.products[0].emailConfig.severityLimit = setSeverity;
        // } else {
        // else if the severity limit object is set, we can then set key value pairs regularly
        if (temp.products[0].emailConfig.severityLimit[key]) {
          if (key === "Any") {
            delete temp.products[0].emailConfig.severityLimit[key];
          } else {
            temp.products[0].emailConfig.severityLimit[key] = false;
          }
        } else if (!temp.products[0].emailConfig.severityLimit[key]) {
          if (key === "Any") {
            temp.products[0].emailConfig.severityLimit = { [key]: true };
          } else {
            const prevSeverityObj = temp.products[0].emailConfig.severityLimit;
            prevSeverityObj[key] = true;
            temp.products[0].emailConfig.severityLimit = prevSeverityObj;
          }
        }
        // }
        setProductParams(temp);
      }
    }
  };

  const handleEmailClosingParagraph = (event: any, type: string) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].emailConfig
      ) {
        let newMessages: any = {};
        if (temp.products[0].emailConfig.emailClosingParagraph) {
          newMessages = temp.products[0].emailConfig.emailClosingParagraph;
        }
        newMessages[type] = event;
        temp.products[0].emailConfig.emailClosingParagraph = newMessages;
        setProductParams(temp);
      }
    }
  };

  const handleEmailOpeningParagraph = (event: any, type: string) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].emailConfig
      ) {
        let newMessages: any = {};
        if (temp.products[0].emailConfig.emailOpeningParagraph) {
          newMessages = temp.products[0].emailConfig.emailOpeningParagraph;
        }
        newMessages[type] = event;
        temp.products[0].emailConfig.emailOpeningParagraph = newMessages;
        setProductParams(temp);
      }
    }
  };

  const clearErrMsg = (errMsg: any) => {
    if (
      errMsg.feedbackEmailSubErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].emailConfig
    ) {
      const msg = { ...errMsg };
      msg.feedbackEmailSubErr = null;
      setErrMsg(msg);
    }
    if (
      errMsg.feedbackEmailBodyErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].emailConfig
    ) {
      const msg = { ...errMsg };
      msg.feedbackEmailBodyErr = null;
      setErrMsg(msg);
    }
    if (
      errMsg.bugEmailSubErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].emailConfig
    ) {
      const msg = { ...errMsg };
      msg.bugEmailSubErr = null;
      setErrMsg(msg);
    }
    if (
      errMsg.bugEmailBodyErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].emailConfig
    ) {
      const msg = { ...errMsg };
      msg.bugEmailBodyErr = null;
      setErrMsg(msg);
    }
    if (
      errMsg.featureEmailSubErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].emailConfig
    ) {
      const msg = { ...errMsg };
      msg.featureEmailSubErr = null;
      setErrMsg(msg);
    }
    if (
      errMsg.featureEmailBodyErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].emailConfig
    ) {
      const msg = { ...errMsg };
      msg.featureEmailBodyErr = null;
      setErrMsg(msg);
    }
  };

  const handleEmailSalutation = (event: any, type: string) => {
    const temp: IProductParams | undefined = cloneDeep(productParams);
    if (
      temp &&
      temp.products &&
      temp.products[0] &&
      temp.products[0].emailConfig
    ) {
      let newMessages: any = {};
      if (temp.products[0].emailConfig.emailSalutation) {
        newMessages = temp.products[0].emailConfig.emailSalutation;
      }
      newMessages[type] = event;
      temp.products[0].emailConfig.emailSalutation = newMessages;
      setProductParams(temp);
    }
  };

  const handleEmailText = (event: any, type: string) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].emailConfig &&
        temp.products[0].emailConfig.emailText
      ) {
        const newMessages = temp.products[0].emailConfig.emailText;
        newMessages[type] = event;
        temp.products[0].emailConfig.emailText = newMessages;
        setProductParams(temp);
      }
      clearErrMsg(errMsg);
    }
  };

  const handleEmailSubject = (event: any, type: string) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].emailConfig
      ) {
        let newMessages: any = {};
        if (temp.products[0].emailConfig.emailSubject) {
          newMessages = temp.products[0].emailConfig.emailSubject;
        }
        newMessages[type] = event.target.value;
        temp.products[0].emailConfig.emailSubject = newMessages;
        setProductParams(temp);
        clearErrMsg(errMsg);
      }
    }
  };

  const handleEmailTextChange = (event: any, fbType: string) => {
    handleEmailText(event, fbType);
  };

  const handleEmailSubjectChange = (event: any, fbType: string) => {
    handleEmailSubject(event, fbType);
  };

  const handleEmailRating = (key: string) => {
    appLogger.info({
      infoObj: {
        method: "handleEmailRating",
        component: "add-product",
        fileName: "emailSettings.tsx",
        selectRating: key,
      },
    });
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].emailConfig &&
        temp.products[0].emailConfig.ratingLimit
      ) {
        if (temp.products[0].emailConfig.ratingLimit[key]) {
          if (key === "0") {
            delete temp.products[0].emailConfig.ratingLimit[key];
          } else {
            temp.products[0].emailConfig.ratingLimit[key] = false;
          }
        } else if (!temp.products[0].emailConfig.ratingLimit[key]) {
          if (key === "0") {
            temp.products[0].emailConfig.ratingLimit = { 0: true };
          } else {
            const prevRatingObj = temp.products[0].emailConfig.ratingLimit;
            prevRatingObj[key] = true;
            temp.products[0].emailConfig.ratingLimit = prevRatingObj;
          }
        }

        setProductParams(temp);
      }
    }
  };

  const handleDisableFeedbackRating = (id: string) => {
    const temp: IProductParams | undefined = cloneDeep(productParams);
    if (temp?.products?.[0]?.emailConfig?.ratingLimit) {
      const keys = Object.keys(temp.products[0].emailConfig.ratingLimit);
      // productParams.products[0].emailConfig.ratingLimit
      if (keys.includes("0") && id !== "0") {
        return true;
      }
    }
    return false;
  };

  const handleDisableBugSeverity = (id: string) => {
    const temp: IProductParams | undefined = cloneDeep(productParams);
    if (temp?.products?.[0]?.emailConfig?.severityLimit) {
      const keys = Object.keys(temp.products[0].emailConfig.severityLimit);
      // productParams.products[0].emailConfig.ratingLimit
      if (keys.includes("Any") && id !== "Any") {
        return true;
      }
    }
    return false;
  };

  const handleEnableEmail = (event: boolean, type: string) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].emailConfig &&
        temp.products[0].emailConfig.feedbackTypes
      ) {
        if (
          event &&
          !temp.products[0].emailConfig.feedbackTypes.includes(type)
        ) {
          temp.products[0].emailConfig.feedbackTypes.push(type);
        } else if (!event) {
          if (temp.products[0].emailConfig.feedbackTypes.includes(type)) {
            const oldEmail = temp.products[0].emailConfig.feedbackTypes;
            const index = oldEmail.indexOf(type);
            oldEmail.splice(index, 1);
            temp.products[0].emailConfig.feedbackTypes = oldEmail;
          }
        }
        setProductParams(temp);
      }
    }
  };

  const handleFeatureCheck = (event: any, currentType: string) => {
    event.preventDefault();
    appLogger.info({
      infoObj: {
        method: "handleFeatureCheck",
        component: "add-product",
        fileName: "emailSettings.tsx",
        featureCheck: featureCheck,
      },
    });
    if (featureCheck) {
      setFeatureChecked(false);
      handleEnableEmail(false, currentType);
    } else {
      setFeatureChecked(true);
      handleEnableEmail(true, currentType);
    }
  };

  const handleBugCheck = (event: any, currentType: string) => {
    event.preventDefault();
    appLogger.info({
      infoObj: {
        method: "handleBugCheck",
        component: "add-product",
        fileName: "emailSettings.tsx",
        bugCheck: bugCheck,
      },
    });
    if (bugCheck) {
      setBugChecked(false);
      handleEnableEmail(false, currentType);
    } else {
      setBugChecked(true);
      handleEnableEmail(true, currentType);
    }
  };

  const handleFdCheck = (event: any, currentType: string) => {
    event.preventDefault();
    appLogger.info({
      infoObj: {
        method: "handleFdCheck",
        component: "add-product",
        fileName: "emailSettings.tsx",
        fdCheck: fdCheck,
      },
    });
    if (fdCheck) {
      setFdChecked(false);
      handleEnableEmail(false, currentType);
    } else {
      setFdChecked(true);
      handleEnableEmail(true, currentType);
    }
  };

  function checkAndSetDefaultValues(product: IProductInfo): IProductInfo {
    if (!product.feedbackAgentSettings) {
      product.feedbackAgentSettings = defaultFeedbackAgentSettings;
    }

    if (!product.orgId) {
      product.orgId =
        (userInfo && userInfo.userDetails && userInfo.userDetails.orgId) ||
        orgId;
    }
    if (
      product.feedbackAgentSettings &&
      !product.feedbackAgentSettings.branding
    ) {
      product.feedbackAgentSettings.branding = defaultBranding;
    }
    return product;
  }

  const handleFetchProduct = () => {
    setLoading(true);
    Http.get({
      url: `/api/v2/products/${productId}/${versionId}`,
      state: userInfo,
    })
      .then((response: any) => {
        setLoading(false);
        appLogger.info({
          infoObj: {
            method: "useEffect",
            component: "add-products",
            fileName: "index.tsx",
            productResponse: response,
          },
        });
        const tempProduct = checkAndSetDefaultValues(response.products[0]);
        if (location && location.state && location.state.cloneNewProduct) {
          response.products[0].id = "";
          response.products[0].version = "";
          response.products[0].name = "";
          response.products[0].apiKey = "";
        } else if (
          location &&
          location.state &&
          location.state.cloneNewVersion
        ) {
          response.products[0].version = "";
          response.products[0].apiKey = "";
          response.products[0].cloneNewVersion = true;
        }
        let tempBugSeverities: string[] = [];

        if (
          response?.products?.[0]?.feedbackAgentSettings?.bugSettings
            ?.severities
        ) {
          tempBugSeverities = [
            "Any",
            ...response?.products?.[0]?.feedbackAgentSettings?.bugSettings
              ?.severities,
          ];
        }

        setBugSeverities(tempBugSeverities);
        setProductParams(response);
      })
      .catch((error: any) => {
        appLogger.error({
          errObj: {
            method: "useEffect",
            component: "add-products",
            fileName: "index.tsx",
            err: error,
          },
        });

        snackbarShowMessage("products fetch error", "error", 3000);
      });
  };

  useEffect(() => {
    if (productId && versionId) {
      handleFetchProduct();
    } else {
      const newProd = checkAndSetDefaultValues({
        id: "",
        version: "",
        name: "",
        status: STATUS_PRODUCT_ACTIVE,
        platform: PLATFORM_TYPE_BROWSER,
        technology: webTechs[0].value,
        orgId:
          (userInfo && userInfo.userDetails && userInfo.userDetails.orgId) ||
          orgId,
      });

      appLogger.info({
        infoObj: {
          method: "useEffect",
          component: "add-products",
          fileName: "index.tsx",
          newProd: newProd,
        },
      });

      setProductParams({ products: [newProd] });
    }
    setGenSettingsAccordianContext(true);
  }, [productId, versionId]);

  useEffect(() => {
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].emailConfig
    ) {
      if (
        productParams.products[0].emailConfig.feedbackTypes.includes(
          FEEDBACK_TYPE_FEEDBACK
        )
      ) {
        setFdChecked(true);
      }
      if (
        productParams.products[0].emailConfig.feedbackTypes.includes(
          FEEDBACK_TYPE_BUGS
        )
      ) {
        setBugChecked(true);
      }
      if (
        productParams.products[0].emailConfig.feedbackTypes.includes(
          FEEDBACK_TYPE_FEATURE_REQ
        )
      ) {
        setFeatureChecked(true);
      }
    }
  }, [productParams]);

  const handleEmailSignature = (event: any, type: string) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].emailConfig
      ) {
        let newMessages: any = {};
        if (temp.products[0].emailConfig.emailSignature) {
          newMessages = temp.products[0].emailConfig.emailSignature;
        }
        newMessages[type] = event;
        temp.products[0].emailConfig.emailSignature = newMessages;
        setProductParams(temp);
      }
    }
  };

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }
  return (
    <div className={loading ? "add-products-wrap loader" : "add-products-wrap"}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          justifyContent: "space-between",
          padding: "0 20px",
        }}
      >
        <Box display="flex" flexDirection="column" justifyContent="end">
          <Typography
            sx={{
              borderBottom: "2px solid #0157FF",
              color: "#0157FF",
              fontFamily: "Poppins",
              fontSize: "14px",
              padding: "12px 0",
              lineHeight: "24px",
              fontWeight: 500,
            }}
          >
            Configure Email
          </Typography>
        </Box>
        <Box>
          <Button
            type="button"
            variant="outlined"
            sx={{ textTransform: "uppercase" }}
            onClick={handleCancel}
            className="create-pro-btn "
            id="pro-cancel"
          >
            close
          </Button>

          <Button
            type="submit"
            variant="contained"
            sx={{ textTransform: "uppercase" }}
            onClick={handleSave}
            className="create-pro-btn guideTourCreateSave"
            id="pro-save"
          >
            {productParams &&
            productParams.products &&
            productParams.products[0] &&
            productParams.products[0].id
              ? "save"
              : "create"}
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          padding: "30px",
          overflowX: "auto",
        }}
      >
        <EmailSettingsHeader product={productParams?.products?.[0]} />

        {userEnabledFeatures?.enableFeedback &&
        enableFeedback &&
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_FEEDBACK
        ) ? (
          <Grid item xs={12}>
            <Box className="feedback-email-wrap">
              <Typography className="title">feedback</Typography>
              <Grid item xs={12}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={fdCheck}
                        onClick={(event) =>
                          handleFdCheck(event, FEEDBACK_TYPE_FEEDBACK)
                        }
                        // value={fdCheck}
                        color="primary"
                      />
                    }
                    label={
                      "Send auto reply email when user submits feedback" /*fdCheck
                    ? 'Enabled email auto reply for user submission'
                : 'Disabled email auto reply for user submission'*/
                    }
                  />
                </Box>
              </Grid>
              {fdCheck ? (
                <>
                  <Typography sx={{ mt: 1.5 }} className="label">
                    Choose ratings that activate email message - can select
                    multiple
                  </Typography>
                  <Grid item className="ratings-chip" xs={12} sx={{ mt: 2 }}>
                    {feedbackRatingslist.map((e: any) => (
                      <Chip
                        key={e.id}
                        disabled={handleDisableFeedbackRating(e.id)}
                        onClick={() => handleEmailRating(e.id)}
                        variant={
                          productParams &&
                          productParams.products &&
                          productParams.products[0] &&
                          productParams.products[0].emailConfig &&
                          productParams.products[0].emailConfig.ratingLimit &&
                          Object.keys(
                            productParams.products[0].emailConfig.ratingLimit
                          ).includes(e.id) &&
                          productParams.products[0].emailConfig.ratingLimit[
                            e.id
                          ]
                            ? "filled"
                            : "outlined"
                        }
                        label={e.name}
                        color="primary"
                      />
                    ))}
                  </Grid>
                  <Grid item xs={12} sx={{ mt: 2 }}>
                    <FormControl className="custom-select" fullWidth>
                      <InputLabel>
                        Subject of email message
                        <div
                          style={{
                            display: "inline-block",
                            color: "red",
                            marginLeft: "1px",
                          }}
                        >
                          *
                        </div>
                        {errMsg.feedbackEmailSubErr &&
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        fdCheck ? (
                          <div
                            style={{ display: "inline-block", color: "red" }}
                          >
                            {errMsg.feedbackEmailSubErr}
                          </div>
                        ) : (
                          <></>
                        )}
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        value={
                          productParams &&
                          productParams.products &&
                          productParams.products[0] &&
                          productParams.products[0].emailConfig &&
                          productParams.products[0].emailConfig.emailSubject &&
                          productParams.products[0].emailConfig.emailSubject[
                            FEEDBACK_TYPE_FEEDBACK
                          ]
                            ? productParams.products[0].emailConfig
                                .emailSubject[FEEDBACK_TYPE_FEEDBACK]
                            : ""
                        }
                        onChange={(event) =>
                          handleEmailSubjectChange(
                            event,
                            FEEDBACK_TYPE_FEEDBACK
                          )
                        }
                        id="feedback-msg-input"
                        label="feedback email msg"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sx={{ mt: 2 }}>
                    <FormControl className="custom-select " fullWidth>
                      <InputLabel className="richtext">
                        Body of auto reply email message
                        <div
                          style={{
                            display: "inline-block",
                            color: "red",
                            marginLeft: "1px",
                          }}
                        >
                          *
                        </div>
                        {errMsg.feedbackEmailBodyErr &&
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        fdCheck ? (
                          <div
                            style={{ display: "inline-block", color: "red" }}
                          >
                            {errMsg.feedbackEmailBodyErr}
                          </div>
                        ) : (
                          <></>
                        )}
                      </InputLabel>
                      <Editor
                        updateData={(event: any) =>
                          handleEmailTextChange(event, FEEDBACK_TYPE_FEEDBACK)
                        }
                        editorData={
                          productParams &&
                          productParams.products &&
                          productParams.products[0] &&
                          productParams.products[0].emailConfig &&
                          productParams.products[0].emailConfig.emailText &&
                          productParams.products[0].emailConfig.emailText[
                            FEEDBACK_TYPE_FEEDBACK
                          ]
                            ? productParams.products[0].emailConfig.emailText[
                                FEEDBACK_TYPE_FEEDBACK
                              ]
                            : ""
                        }
                        id="feedback-msg-input"
                        label="feedback email text"
                      />
                    </FormControl>
                  </Grid>

                  <div
                    style={{ marginTop: "20px", border: "1px solid grey" }}
                  ></div>
                </>
              ) : null}
              <>
                <Typography sx={{ mt: 1.5 }} className="label">
                  {`Insert #{{productname}} and #{{productversion}} in the text if you want to put these values in the mail`}
                </Typography>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel className="richtext">
                      Salutation of email message
                    </InputLabel>
                    <Editor
                      updateData={(event: any) =>
                        handleEmailSalutation(event, FEEDBACK_TYPE_FEEDBACK)
                      }
                      editorData={
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        productParams.products[0].emailConfig.emailSalutation &&
                        productParams.products[0].emailConfig.emailSalutation[
                          FEEDBACK_TYPE_FEEDBACK
                        ]
                          ? productParams.products[0].emailConfig
                              .emailSalutation[FEEDBACK_TYPE_FEEDBACK]
                          : ""
                      }
                      id="feedback-msg-input"
                      label="feedback email salutation"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel className="richtext">
                      Opening paragraph of email message
                    </InputLabel>
                    <Editor
                      updateData={(event: any) =>
                        handleEmailOpeningParagraph(
                          event,
                          FEEDBACK_TYPE_FEEDBACK
                        )
                      }
                      editorData={
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        productParams.products[0].emailConfig
                          .emailOpeningParagraph &&
                        productParams.products[0].emailConfig
                          .emailOpeningParagraph[FEEDBACK_TYPE_FEEDBACK]
                          ? productParams.products[0].emailConfig
                              .emailOpeningParagraph[FEEDBACK_TYPE_FEEDBACK]
                          : ""
                      }
                      id="feedback-msg-input"
                      label="feedback email opening paragraph"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel className="richtext">
                      Closing paragraph of email message
                    </InputLabel>
                    <Editor
                      updateData={(event: any) =>
                        handleEmailClosingParagraph(
                          event,
                          FEEDBACK_TYPE_FEEDBACK
                        )
                      }
                      editorData={
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        productParams.products[0].emailConfig
                          .emailClosingParagraph &&
                        productParams.products[0].emailConfig
                          .emailClosingParagraph[FEEDBACK_TYPE_FEEDBACK]
                          ? productParams.products[0].emailConfig
                              .emailClosingParagraph[FEEDBACK_TYPE_FEEDBACK]
                          : ""
                      }
                      id="feedback-msg-input"
                      label="feedback email closing paragraph"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel className="richtext">
                      Signature of email message
                    </InputLabel>
                    <Editor
                      updateData={(event: any) =>
                        handleEmailSignature(event, FEEDBACK_TYPE_FEEDBACK)
                      }
                      editorData={
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        productParams.products[0].emailConfig.emailSignature &&
                        productParams.products[0].emailConfig.emailSignature[
                          FEEDBACK_TYPE_FEEDBACK
                        ]
                          ? productParams.products[0].emailConfig
                              .emailSignature[FEEDBACK_TYPE_FEEDBACK]
                          : ""
                      }
                      id="feedback-msg-input"
                      label="feedback email signature"
                    />
                  </FormControl>
                </Grid>
              </>
            </Box>
          </Grid>
        ) : (
          <></>
        )}
        {((userEnabledFeatures?.enableBugReport && enableBugReport) ||
          (userEnabledFeatures?.enableChatbot && enableChatbot)) &&
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_BUGS
        ) ? (
          <Grid sx={{ mt: 2 }} item xs={12}>
            <Box className="bug-email-wrap">
              <Typography className="title">Tickets</Typography>

              <Grid item xs={12}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={bugCheck}
                        onClick={(event) =>
                          handleBugCheck(event, FEEDBACK_TYPE_BUGS)
                        }
                        // value={bugCheck}
                        color="primary"
                      />
                    }
                    label={
                      "Send auto reply email when user reports tickets" /*bugCheck
                    ? 'Enabled email auto reply for user submission'
                : 'Disabled email auto reply for user submission'*/
                    }
                  />
                </Box>
              </Grid>
              {bugCheck ? (
                <>
                  <Typography sx={{ mt: 1.5 }} className="label">
                    Choose severities that activate email message - can select
                    multiple
                  </Typography>
                  <Grid item className="ratings-chip" xs={12} sx={{ mt: 2 }}>
                    {bugSeverities.length > 0
                      ? bugSeverities.map((val: any) => (
                          <Chip
                            key={val}
                            disabled={handleDisableBugSeverity(val)}
                            onClick={() => handleEmailSeverity(val)}
                            variant={
                              productParams &&
                              productParams.products &&
                              productParams.products[0] &&
                              productParams.products[0].emailConfig &&
                              productParams.products[0].emailConfig
                                .severityLimit &&
                              Object.keys(
                                productParams.products[0].emailConfig
                                  .severityLimit
                              ).includes(val) &&
                              productParams.products[0].emailConfig
                                .severityLimit[val]
                                ? "filled"
                                : "outlined"
                            }
                            label={val}
                            color="primary"
                          />
                        ))
                      : " No severity "}
                  </Grid>
                  <Grid item xs={12} sx={{ mt: 2 }}>
                    <FormControl
                      className="custom-select custom-textarea"
                      fullWidth
                    >
                      <InputLabel>
                        Subject of email message
                        <div
                          style={{
                            display: "inline-block",
                            color: "red",
                            marginLeft: "1px",
                          }}
                        >
                          *
                        </div>
                        {errMsg.bugEmailSubErr &&
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        bugCheck ? (
                          <div
                            style={{ display: "inline-block", color: "red" }}
                          >
                            {errMsg.bugEmailSubErr}
                          </div>
                        ) : (
                          <></>
                        )}
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        value={
                          productParams &&
                          productParams.products &&
                          productParams.products[0] &&
                          productParams.products[0].emailConfig &&
                          productParams.products[0].emailConfig.emailSubject &&
                          productParams.products[0].emailConfig.emailSubject[
                            FEEDBACK_TYPE_BUGS
                          ]
                            ? productParams.products[0].emailConfig
                                .emailSubject[FEEDBACK_TYPE_BUGS]
                            : ""
                        }
                        onChange={(event) =>
                          handleEmailSubjectChange(event, FEEDBACK_TYPE_BUGS)
                        }
                        id="bug-msg-input"
                        label="bug email subject"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sx={{ mt: 2 }}>
                    <FormControl className="custom-select" fullWidth>
                      <InputLabel className="richtext">
                        Body of auto reply email message
                        <div
                          style={{
                            display: "inline-block",
                            color: "red",
                            marginLeft: "1px",
                          }}
                        >
                          *
                        </div>
                        {errMsg.bugEmailBodyErr &&
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        bugCheck ? (
                          <div
                            style={{ display: "inline-block", color: "red" }}
                          >
                            {errMsg.bugEmailBodyErr}
                          </div>
                        ) : (
                          <></>
                        )}
                      </InputLabel>
                      <Editor
                        updateData={(event: any) =>
                          handleEmailTextChange(event, FEEDBACK_TYPE_BUGS)
                        }
                        editorData={
                          productParams &&
                          productParams.products &&
                          productParams.products[0] &&
                          productParams.products[0].emailConfig &&
                          productParams.products[0].emailConfig.emailText &&
                          productParams.products[0].emailConfig.emailText[
                            FEEDBACK_TYPE_BUGS
                          ]
                            ? productParams.products[0].emailConfig.emailText[
                                FEEDBACK_TYPE_BUGS
                              ]
                            : ""
                        }
                        id="bug-msg-input"
                        label="bug email msg"
                      />
                    </FormControl>
                  </Grid>
                  <div
                    style={{ marginTop: "20px", border: "1px solid grey" }}
                  ></div>
                </>
              ) : null}
              <>
                <Typography sx={{ mt: 1.5 }} className="label">
                  {`Insert #{{productname}} and #{{productversion}} in the text if you want to put these values in the mail`}
                </Typography>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel className="richtext">
                      Salutation of email message
                    </InputLabel>
                    <Editor
                      updateData={(event: any) =>
                        handleEmailSalutation(event, FEEDBACK_TYPE_BUGS)
                      }
                      editorData={
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        productParams.products[0].emailConfig.emailSalutation &&
                        productParams.products[0].emailConfig.emailSalutation[
                          FEEDBACK_TYPE_BUGS
                        ]
                          ? productParams.products[0].emailConfig
                              .emailSalutation[FEEDBACK_TYPE_BUGS]
                          : ""
                      }
                      id="bug-msg-input"
                      label="bug email salutation"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel className="richtext">
                      Opening paragraph of email message
                    </InputLabel>
                    <Editor
                      updateData={(event: any) =>
                        handleEmailOpeningParagraph(event, FEEDBACK_TYPE_BUGS)
                      }
                      editorData={
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        productParams.products[0].emailConfig
                          .emailOpeningParagraph &&
                        productParams.products[0].emailConfig
                          .emailOpeningParagraph[FEEDBACK_TYPE_BUGS]
                          ? productParams.products[0].emailConfig
                              .emailOpeningParagraph[FEEDBACK_TYPE_BUGS]
                          : ""
                      }
                      id="bug-msg-input"
                      label="bug email opening paragraph"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel className="richtext">
                      Closing paragraph of email message
                    </InputLabel>
                    <Editor
                      updateData={(event: any) =>
                        handleEmailClosingParagraph(event, FEEDBACK_TYPE_BUGS)
                      }
                      editorData={
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        productParams.products[0].emailConfig
                          .emailClosingParagraph &&
                        productParams.products[0].emailConfig
                          .emailClosingParagraph[FEEDBACK_TYPE_BUGS]
                          ? productParams.products[0].emailConfig
                              .emailClosingParagraph[FEEDBACK_TYPE_BUGS]
                          : ""
                      }
                      id="bug-msg-input"
                      label="bug email closing paragraph"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel className="richtext">
                      Signature of email message
                    </InputLabel>
                    <Editor
                      updateData={(event: any) =>
                        handleEmailSignature(event, FEEDBACK_TYPE_BUGS)
                      }
                      editorData={
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        productParams.products[0].emailConfig.emailSignature &&
                        productParams.products[0].emailConfig.emailSignature[
                          FEEDBACK_TYPE_BUGS
                        ]
                          ? productParams.products[0].emailConfig
                              .emailSignature[FEEDBACK_TYPE_BUGS]
                          : ""
                      }
                      id="bug-msg-input"
                      label="bug email signature"
                    />
                  </FormControl>
                </Grid>
              </>
            </Box>
          </Grid>
        ) : (
          <></>
        )}
        {userEnabledFeatures?.enableFeatureRequest &&
        enableFeatureRequest &&
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
          "FEATURE_REQUEST"
        ) ? (
          <Grid item xs={12} sx={{ mt: 2 }}>
            <Box className="feature-email-wrap">
              <Typography className="title">feature Request</Typography>
              <Grid item xs={12}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={featureCheck}
                        onClick={(event) =>
                          handleFeatureCheck(event, FEEDBACK_TYPE_FEATURE_REQ)
                        }
                        // value={featureCheck}
                        color="primary"
                      />
                    }
                    label={
                      "Send auto reply email when user submits feedback" /*fdCheck
                    ? 'Enabled email auto reply for user submission'
                : 'Disabled email auto reply for user submission'*/
                    }
                  />
                </Box>
              </Grid>
              {featureCheck ? (
                <>
                  <Grid item xs={12} sx={{ mt: 2 }}>
                    <FormControl
                      className="custom-select custom-textarea"
                      fullWidth
                    >
                      <InputLabel>
                        Subject of email message
                        <div
                          style={{
                            display: "inline-block",
                            color: "red",
                            marginLeft: "1px",
                          }}
                        >
                          *
                        </div>
                        {errMsg.featureEmailSubErr &&
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        featureCheck ? (
                          <div
                            style={{ display: "inline-block", color: "red" }}
                          >
                            {errMsg.featureEmailSubErr}
                          </div>
                        ) : (
                          <></>
                        )}
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        value={
                          productParams &&
                          productParams.products &&
                          productParams.products[0] &&
                          productParams.products[0].emailConfig &&
                          productParams.products[0].emailConfig.emailSubject &&
                          productParams.products[0].emailConfig.emailSubject[
                            FEEDBACK_TYPE_FEATURE_REQ
                          ]
                            ? productParams.products[0].emailConfig
                                .emailSubject[FEEDBACK_TYPE_FEATURE_REQ]
                            : ""
                        }
                        onChange={(event) =>
                          handleEmailSubjectChange(
                            event,
                            FEEDBACK_TYPE_FEATURE_REQ
                          )
                        }
                        id="feature-msg-input"
                        label="feature email subject"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sx={{ mt: 2 }}>
                    <FormControl className="custom-select" fullWidth>
                      <InputLabel className="richtext">
                        Body of auto reply email message
                        <div
                          style={{
                            display: "inline-block",
                            color: "red",
                            marginLeft: "1px",
                          }}
                        >
                          *
                        </div>
                        {errMsg.featureEmailBodyErr &&
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        featureCheck ? (
                          <div
                            style={{ display: "inline-block", color: "red" }}
                          >
                            {errMsg.featureEmailBodyErr}
                          </div>
                        ) : (
                          <></>
                        )}
                      </InputLabel>
                      <Editor
                        updateData={(event: any) =>
                          handleEmailTextChange(
                            event,
                            FEEDBACK_TYPE_FEATURE_REQ
                          )
                        }
                        editorData={
                          productParams &&
                          productParams.products &&
                          productParams.products[0] &&
                          productParams.products[0].emailConfig &&
                          productParams.products[0].emailConfig.emailText &&
                          productParams.products[0].emailConfig.emailText[
                            FEEDBACK_TYPE_FEATURE_REQ
                          ]
                            ? productParams.products[0].emailConfig.emailText[
                                FEEDBACK_TYPE_FEATURE_REQ
                              ]
                            : ""
                        }
                        id="feature-msg-input"
                        label="feature email msg"
                      />
                    </FormControl>
                  </Grid>
                  <div
                    style={{ marginTop: "20px", border: "1px solid grey" }}
                  ></div>
                </>
              ) : null}
              <>
                <Typography sx={{ mt: 1.5 }} className="label">
                  {`Insert #{{productname}} and #{{productversion}} in the text if you want to put these values in the mail`}
                </Typography>
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel className="richtext">
                      Salutation of email message
                    </InputLabel>
                    <Editor
                      updateData={(event: any) =>
                        handleEmailSalutation(event, FEEDBACK_TYPE_FEATURE_REQ)
                      }
                      editorData={
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        productParams.products[0].emailConfig.emailSalutation &&
                        productParams.products[0].emailConfig.emailSalutation[
                          FEEDBACK_TYPE_FEATURE_REQ
                        ]
                          ? productParams.products[0].emailConfig
                              .emailSalutation[FEEDBACK_TYPE_FEATURE_REQ]
                          : ""
                      }
                      id="feature-msg-input"
                      label="feature email salutation"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel className="richtext">
                      Opening paragraph of email message
                    </InputLabel>
                    <Editor
                      updateData={(event: any) =>
                        handleEmailOpeningParagraph(
                          event,
                          FEEDBACK_TYPE_FEATURE_REQ
                        )
                      }
                      editorData={
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        productParams.products[0].emailConfig
                          .emailOpeningParagraph &&
                        productParams.products[0].emailConfig
                          .emailOpeningParagraph[FEEDBACK_TYPE_FEATURE_REQ]
                          ? productParams.products[0].emailConfig
                              .emailOpeningParagraph[FEEDBACK_TYPE_FEATURE_REQ]
                          : ""
                      }
                      id="feature-msg-input"
                      label="feature email opening paragraph"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel className="richtext">
                      Closing paragraph of email message
                    </InputLabel>
                    <Editor
                      updateData={(event: any) =>
                        handleEmailClosingParagraph(
                          event,
                          FEEDBACK_TYPE_FEATURE_REQ
                        )
                      }
                      editorData={
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        productParams.products[0].emailConfig
                          .emailClosingParagraph &&
                        productParams.products[0].emailConfig
                          .emailClosingParagraph[FEEDBACK_TYPE_FEATURE_REQ]
                          ? productParams.products[0].emailConfig
                              .emailClosingParagraph[FEEDBACK_TYPE_FEATURE_REQ]
                          : ""
                      }
                      id="feature-msg-input"
                      label="feature email closing paragraph"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel className="richtext">
                      Signature of email message
                    </InputLabel>
                    <Editor
                      updateData={(event: any) =>
                        handleEmailSignature(event, FEEDBACK_TYPE_FEATURE_REQ)
                      }
                      editorData={
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].emailConfig &&
                        productParams.products[0].emailConfig.emailSignature &&
                        productParams.products[0].emailConfig.emailSignature[
                          FEEDBACK_TYPE_FEATURE_REQ
                        ]
                          ? productParams.products[0].emailConfig
                              .emailSignature[FEEDBACK_TYPE_FEATURE_REQ]
                          : ""
                      }
                      id="feature-msg-input"
                      label="feature email signature"
                    />
                  </FormControl>
                </Grid>
              </>
            </Box>
          </Grid>
        ) : (
          <></>
        )}
      </Box>
    </div>
  );
};

export default withSnackbar(EmailSettings);
